import { getProducts } from "../../../Admin/State/Product/Action";
import { privateAxios } from "../../../config/apiConfig";
import { getAllProduct } from "../Product/Action";
import {
  CREATE_VARIANT_FAILURE,
  CREATE_VARIANT_REQUEST,
  DELETE_VARIANT_REQUEST,
  DELETE_VARIANT_FAILURE,
  UPDATE_VARIANT_REQUEST,
  UPDATE_VARIANT_FAILURE,
  CREATE_VARIANT_SUCCESS,
  UPDATE_VARIANT_SUCCESS,
  DELETE_VARIANT_SUCCESS,
} from "./ActionType";
import { toast } from "react-toastify";

export const createVariant = (productId, variantData) => async (dispatch) => {
  dispatch({ type: CREATE_VARIANT_REQUEST });
  try {
    const { data } = await privateAxios.post(`vendor/product_variant/product/${productId}`, variantData);
    if (data?.status === "SUCCESS") {
      dispatch(getAllProduct());
      dispatch(getProducts());
      toast.success(data?.response);
      dispatch({ type: CREATE_VARIANT_SUCCESS, payload: data?.response });
    } else {
      toast.error(data.response);
    }
  } catch (error) {
    if (error.response.data.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: CREATE_VARIANT_FAILURE, payload: error.message });
  }
};

export const updateVariant = (variantId, variantData) => async (dispatch) => {
  dispatch({ type: UPDATE_VARIANT_REQUEST });
  try {
    const { data } = await privateAxios.put(
      `vendor/product_variant/${variantId}`,
      variantData
    );
    if (data.status === "SUCCESS") {
      dispatch(getAllProduct());
      dispatch(getProducts());
      toast.success("variant Updated Successfully");
      dispatch({ type: UPDATE_VARIANT_SUCCESS, payload: data?.response });
    } else {
      toast.error(data.response);
    }
  } catch (error) {
    if (error.response.data.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: UPDATE_VARIANT_FAILURE, payload: error.message });
  }
};

export const deleteVariant = (variantId) => async (dispatch) => {
  dispatch({ type: DELETE_VARIANT_REQUEST });
  try {
    const { data } = await privateAxios.delete(`vendor/product_variant/${variantId}`);
    if (data.status === "SUCCESS") {
      dispatch(getAllProduct());
      dispatch(getProducts());
      toast.success(data.response);
      dispatch({ type: DELETE_VARIANT_SUCCESS, payload: variantId })
    } else {
      toast.error(data.response);
    }
  } catch (error) {
    if (error.response.data.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: DELETE_VARIANT_FAILURE, payload: error.message });
  }
};
